import { Navigate } from 'react-router-dom';
import { Role } from '../types/auth.type';
import { useAuthStore } from '../store/auth.store';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRoles: Role[];
}

export default function ProtectedRoute({ children, requiredRoles }: ProtectedRouteProps) {
  const { user, isInitialized } = useAuthStore();

  if (!isInitialized) {
    return <></>;
  }

  if (user === null) {
    return <Navigate to="/login" replace />;
  }

  if (!user?.role || !requiredRoles.includes(user.role)) {
    return <Navigate to="/not-authorized" replace />;
  }

  return <>{children}</>;
}
